import React from 'react';
import FinanceOverview from '../components/FinanceOverview';

const FinanceOverviewApp = (props) => <FinanceOverview {...props} />;

export default FinanceOverviewApp;
